import { h, Component } from 'preact';
import cx from 'classnames';
import style from './style';
import imageRequire from '../../images/flag/';

export default class Flag extends Component {
	shouldComponentUpdate() { return false; }

	//TODO: Get the flag svgs to load properly in webpack setup
	render({ country }) {
		return (
			<div class={cx(style.flag, country && style[`flag-${country}`])}>
				<img src={imageRequire(`./${country}`)} />
			</div>
		);
	}
}
